import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LoginRedirectComponent } from './login-redirect/login-redirect.component';
import { LandingComponent } from './landing/landing.component';
import { AuthGuard } from './common/services/auth/auth.guard';
import { PageDataResolver } from './common/services/page/page-data-resolver.service';
import { ErrorComponent } from './error/error.component';
import { loginAuthGuard } from './common/services/auth/login-auth.guard';
import { hostRedirectionGuard } from './common/services/auth/host-redirection.guard';
import { RedirectionComponent } from './common/components/redirection/redirection.component';
import { ArticleGuard } from './common/services/auth/article.guard';
import { HelpAreaInfoGuard } from './common/services/auth/help-area-info.guard';
import { LPMI_ROUTES } from './common/constants/routes';

export const routes: Routes = [

  {
    path: '',
    component: RedirectionComponent,
    canActivate: [hostRedirectionGuard],
    pathMatch: 'full'
  },
  {
    path: LPMI_ROUTES.REDIRECTION.PATH,
    component: RedirectionComponent,
    canActivate: [hostRedirectionGuard],
    pathMatch: 'full'
  },
  {
    path: LPMI_ROUTES.ERROR.PATH,
    component: ErrorComponent,
    pathMatch: 'full',
    data: {
      hideHeader: true,
      hideFooter: true,
      pageCategory: 'error page',
      pagePath: LPMI_ROUTES.ERROR.PATH,
      subCategory: 'Failure Event',
    },
  },
  {
    path: LPMI_ROUTES.LOGIN.PATH,
    canActivate: [loginAuthGuard],
    component: LoginComponent,
    resolve: { pageData: PageDataResolver },
    data: {
      hideHeader: true,
      hideFooter: true,
      pageCategory: 'login page',
      subCategory: 'Login Interaction',
      pagePath: LPMI_ROUTES.LOGIN.PATH,
      loadComponent: () =>
        import('./login/login.component').then(m => m.LoginComponent),
    },
  },
  {
    path: LPMI_ROUTES.LOGIN_REDIRECT.PATH,
    component: LoginRedirectComponent,
    pathMatch: 'full',
    data: { hideHeader: true, hideFooter: true },
    resolve: { pageData: PageDataResolver },
  },
   {
    path: LPMI_ROUTES.ARTICLE.PATH,
    loadComponent: () =>
      import('./article-page/article-page.component').then(
        (m) => m.ArticlePageComponent
      ),
    canActivate: [AuthGuard, ArticleGuard],
    resolve: { pageData: PageDataResolver },
    data: {
      breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.ARTICLE],
      pageCategory: 'article page',
      pagePath: LPMI_ROUTES.ARTICLE.PATH,
      subCategory: 'Article Interaction',
    },
  },
  //  {
  //   path: `${LPMI_ROUTES.DEALER_HELP_DESK.PATH}/:appName`,
  //   loadComponent: () =>
  //     import('./help-area-info/help-area-info.component').then((m) => m.HelpAreaInfoComponent),
  //   canActivate: [HelpAreaInfoGuard],
  //   resolve: { pageData: PageDataResolver },
  //   data: {
  //     breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.DEALER_HELP_DESK],
  //     pageCategory: 'dealer help desk page',
  //     pagePath: LPMI_ROUTES.DEALER_HELP_DESK.PATH,
  //     subCategory: LPMI_ROUTES.DEALER_HELP_DESK.PAGE,
  //   },
  // },
  {
    path: `${LPMI_ROUTES.HELP_AREA_INFO.PATH}/:appName`,
    loadComponent: () =>
      import('./help-area-info/help-area-info.component').then((m) => m.HelpAreaInfoComponent),
    canActivate: [AuthGuard, HelpAreaInfoGuard],
    resolve: { pageData: PageDataResolver },
    data: {
      breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.DEALER_HELP_DESK],
      pageCategory: 'help area page',
      pagePath: LPMI_ROUTES.HELP_AREA_INFO.PATH,
      subCategory: LPMI_ROUTES.HELP_AREA_INFO.PAGE,
    },
  },
  {
    path: `${LPMI_ROUTES.WARRANTY_SUPPORT.PATH}/:appName`,
    loadComponent: () =>
      import('./warranty-support/warranty-support.component').then((m) => m.WarrantySupportComponent),
    canActivate: [AuthGuard, HelpAreaInfoGuard],
    resolve: { pageData: PageDataResolver },
    data: {
      breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.WARRANTY_SUPPORT],
      pageCategory: 'warranty support page',
      pagePath: LPMI_ROUTES.WARRANTY_SUPPORT.PATH,
      subCategory: LPMI_ROUTES.WARRANTY_SUPPORT.PAGE,
    },
  },
   {
    path: `${LPMI_ROUTES.HQ_IMPORTERS.PATH}/:appName`,
    loadComponent: () =>
      import('./hq-importers/hq-importers.component').then((m) => m.HqImportersComponent),
    canActivate: [AuthGuard, HelpAreaInfoGuard],
    resolve: { pageData: PageDataResolver },
    data: {
      breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.HQ_IMPORTERS],
      pageCategory: 'hq importes page',
      pagePath: LPMI_ROUTES.HQ_IMPORTERS.PATH,
      subCategory: LPMI_ROUTES.HQ_IMPORTERS.PAGE,
    },
  },
  {
    path: LPMI_ROUTES.LANDING.PATH,
    component: LandingComponent,
    data: {
      breadcrumb: [LPMI_ROUTES.LANDING],
      pageCategory: 'home page',
      loadComponent: () =>
        import('./landing/landing.component').then(m => m.LandingComponent),
      pagePath: LPMI_ROUTES.LANDING.PATH,
      subCategory: 'Landing Experience',
    },
    resolve: { pageData: PageDataResolver },
    canActivate: [AuthGuard],
  },
  // Lazy-loaded routes
  {
    path: LPMI_ROUTES.NOTIFICATION.PATH,
    loadComponent: () =>
      import('./notification-tabs/notification-tabs.component').then(
        (m) => m.NotificationTabsComponent
      ),
    resolve: { pageData: PageDataResolver },
    data: {
      breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.NOTIFICATION],
      pageCategory: 'notification page',
      pagePath: LPMI_ROUTES.NOTIFICATION.PATH,
      subCategory: 'User Notifications',
    },
  },
 
 
  {
    path: LPMI_ROUTES.FAQ.PATH,
    loadComponent: () =>
      import('./faq/faq.component').then((m) => m.FaqComponent),
    resolve: { pageData: PageDataResolver },
    data: {
      breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.FAQ],
      pageCategory: 'faq page',
      pagePath: LPMI_ROUTES.FAQ.PATH,
      subCategory: 'Common Questions',
    },
  },
  {
    path: `${LPMI_ROUTES.FAQ.PATH }/:appName`,
    loadComponent: () =>
      import('./faq/faq.component').then((m) => m.FaqComponent),
    resolve: { pageData: PageDataResolver },
    data: {
      breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.FAQ],
      pageCategory: 'faq page',
      pagePath: LPMI_ROUTES.FAQ.PATH,
      subCategory: 'Common Questions',
    },
  },
  {
    path: LPMI_ROUTES.SITE_STATUS.PATH,
    loadComponent: () =>
      import('./footer/site-status/site-status.component').then(
        (m) => m.SiteStatusComponent
      ),
    resolve: { pageData: PageDataResolver },
    data: {
      hideHeader: localStorage.getItem('nuc.access-token') ? false : true,
      hideFooter: localStorage.getItem('nuc.access-token') ? false : true,
      breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.SITE_STATUS],
      pageCategory: 'site status page',
      pagePath: LPMI_ROUTES.SITE_STATUS.PATH,
      subCategory: 'Platform Status',
    },
  },

  {
    path: LPMI_ROUTES.NEWS_ANNOUNCEMENTS.PATH,
    loadComponent: () =>
      import('./landing/leap-motor-landing/leap-motor-news/leap-motor-news.component').then((m) => m.LeapMotorNewsComponent),
    resolve: { pageData: PageDataResolver },
    data: {
      breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.NEWS_ANNOUNCEMENTS],
      pageCategory: 'news announcements page',
      pagePath: LPMI_ROUTES.NEWS_ANNOUNCEMENTS.PATH,
      subCategory: 'News Center',
      showAll: true
    },
  },
  {
    path: `${LPMI_ROUTES.INFO_MANUAL.PATH}/:appName`,
    loadComponent: () =>
      import('./info-manual/info-manual.component').then((m) => m.InfoManualComponent),
    resolve: { pageData: PageDataResolver },
    data: {
      breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.INFO_MANUAL],
      pageCategory: 'info manual page',
      pagePath: LPMI_ROUTES.INFO_MANUAL.PATH,
      subCategory: 'Info Manual',
    },
  },
 
  {
    path: LPMI_ROUTES.HELP_AREA_INFO_ARTICLE.PATH,
    loadComponent: () =>
      import('./help-area-info/help-area-article-info/help-area-article-info.component').then((m) => m.HelpAreaArticleInfoComponent),
    resolve: { pageData: PageDataResolver },
    data: {
      breadcrumb: [LPMI_ROUTES.LANDING, LPMI_ROUTES.HELP_AREA_INFO_ARTICLE],
      pageCategory: 'help area article page',
      pagePath: LPMI_ROUTES.HELP_AREA_INFO_ARTICLE.PATH,
      subCategory: 'Help Area Article',
    },
  },
  {
    path: '**',
    redirectTo: LPMI_ROUTES.ERROR.PATH,
  },

];
